import { Grades } from '../../../../../../landing/models/GradeInfo';
export var SortGroupType;
(function (SortGroupType) {
    SortGroupType[SortGroupType["None"] = 0] = "None";
    SortGroupType[SortGroupType["Grade"] = 1] = "Grade";
    SortGroupType[SortGroupType["Level"] = 2] = "Level";
    SortGroupType[SortGroupType["Time"] = 3] = "Time";
})(SortGroupType || (SortGroupType = {}));
export var getStudentTimelineLinkBySupervizor = function (schoolId, teacherId, groupId, studentId) {
    return "/administrators/schools/" + schoolId + "/teachers/" + teacherId + "/groups/" + groupId + "/students/" + studentId + "/timeline";
};
export var getStudentTimelineLinkByTeacher = function (groupId, studentId) { return "/teachers/g/" + groupId + "/timeline/" + studentId; };
// https://40364.stagehn.com/teachers/g/421353/timeline/3937989
// http://localhost:3000/administrators/schools/238523/teachers/18641/groups/421353/students/3937989/timeline
